import moment from 'moment/moment'
import store from '@/store'

export function setDefaultTimeZone (timeZone: string) {
  moment.tz.setDefault(timeZone)
  store.dispatch('setup/setInitialTimeZone', timeZone)
}
